var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsermar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#FF9E1B",
    stroke: "#FF9E1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 5.5C10.251 5.5 8.83325 6.91777 8.83325 8.66667C8.83325 10.4156 10.251 11.8333 11.9999 11.8333C13.7488 11.8333 15.1666 10.4156 15.1666 8.66667C15.1666 6.91777 13.7488 5.5 11.9999 5.5ZM9.83325 8.66667C9.83325 7.47005 10.8033 6.5 11.9999 6.5C13.1965 6.5 14.1666 7.47005 14.1666 8.66667C14.1666 9.86328 13.1965 10.8333 11.9999 10.8333C10.8033 10.8333 9.83325 9.86328 9.83325 8.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 13.5C8.25102 13.5 6.83325 14.9178 6.83325 16.6667C6.83325 17.6792 7.65406 18.5 8.66659 18.5H15.3333C16.3458 18.5 17.1666 17.6792 17.1666 16.6667C17.1666 14.9178 15.7488 13.5 13.9999 13.5H9.99992ZM7.83325 16.6667C7.83325 15.47 8.8033 14.5 9.99992 14.5H13.9999C15.1965 14.5 16.1666 15.47 16.1666 16.6667C16.1666 17.1269 15.7935 17.5 15.3333 17.5H8.66659C8.20635 17.5 7.83325 17.1269 7.83325 16.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsermar2);
export default __webpack_public_path__ + "static/media/usermar2.6d42d038e3d6e14a71fed88b83aa08bd.svg";
export { ForwardRef as ReactComponent };